<template>
  <div class="login-page">
    <vue-headful title="ALICE | LOGIN"></vue-headful>
    <div class="row justify-content-md-center">
      <div class="col col-sm-4">
        <form @submit.prevent="login">
          <div class="box">
            <h3 class="is-size-3">Login</h3>
            <div class="field">
              <label class="label">Username</label>
              <div class="control">
                <input type="text" class="input" v-model="username" />
              </div>
            </div>
            <div class="field">
              <label class="label">Password</label>
              <div class="control">
                <input type="password" class="input" v-model="password" />
              </div>
            </div>
            <div class="field">
              <div class="control has-text-centered">
                <input type="submit" class="button is-primary" @click="login" value="Login" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import { mapActions } from 'vuex';
import { mapActions } from 'vuex';
import alice from '../alice-api';

export default {
  name: 'home',
  data() {
    return {
      loggingIn: false,
      username: '',
      password: '',
    };
  },
  methods: {
    ...mapActions({
      setUserData: 'config/setUserData',
    }),
    login() {
      if (this.loggingIn) return false;
      this.loggingIn = true;
      alice
        .login(this.username, this.password)
        .then((result) => {
          alice.login_setup(result.data.access_token).then(async () => {
            alice.setAccessToken(result.data.access_token);
            try {
              const userResult = await alice.getUserInfo();
              if (userResult.data && userResult.data.data) {
                const d = userResult.data.data;
                const userData = {
                  username: d.username,
                  role: d.role,
                };
                alice.setUser(userData);
                this.setUserData(userData);
                this.$router.push({ name: 'home' });
              } else {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: 'Login failed, user information is missing.',
                  position: 'is-bottom',
                });
              }
            } catch (e) {
              // console.log('Cannot get user info');
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Login failed, cannot get user information.',
                position: 'is-bottom',
              });
            }
          });
        })
        .catch(() => {
          // console.error(e);
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Login failed, please check your username and password.',
            position: 'is-bottom',
          });
        })
        .finally(() => {
          this.loggingIn = false;
        });
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.login-page {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-content: space-around;
  justify-content: center;
}
.title-ldd {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-ldd .title-label {
  color: #363636;
  display: block;
  font-size: 1.5rem;
  font-weight: 500;
}
.selection-link {
  display: flex;
  align-items: center;
  border: 2px solid #e4e4e4 !important;
  border-radius: 10px;
  justify-content: space-around;
  background-color: #fff;
  gap: 10px;
}
.selection-link .title-label {
  color: #363636;
  display: block;
  font-size: 1.2rem;
  font-weight: 500;
}
@media (max-width: 1190px) {
  .title-ldd .title-label {
  color: #363636;
  display: block;
  font-size: 1.2rem;
  font-weight: 500;
}
}
</style>
